import { Box, Typography } from "@mui/material";
import { useState } from "react";
import SearchAndOrFilter from "../../components/filters/SearchAndOrFilter";

// Example options similar to ControlsView usage
const mockOptions = [
  { name: "asset1", label: "Asset 1", displayName: "Asset 1" },
  { name: "asset2", label: "Asset 2", displayName: "Asset 2" },
  { name: "asset3", label: "Asset 3", displayName: "Asset 3" },
];

const LOGIC_OR = "OR";

const SearchAndOrFilterDemo = () => {
  const [appliedFilters, setAppliedFilters] = useState({ criticalAssets: {} });
  const [filterLogic, setFilterLogic] = useState({ criticalAssets: LOGIC_OR });

  // Get selected values as array of keys with truthy values
  const selected = Object.keys(appliedFilters.criticalAssets || {}).filter(
    (k) => appliedFilters.criticalAssets[k]
  );

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle1">
        SearchAndOrFilter Example (Affecting Critical Asset)
      </Typography>
      <SearchAndOrFilter
        filterName="Affecting Critical Asset"
        fieldName="criticalAssets"
        options={mockOptions}
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        filterLogic={filterLogic.criticalAssets}
        setFilterLogic={(logic) =>
          setFilterLogic({ ...filterLogic, criticalAssets: logic })
        }
        displayAs="chip"
      />
      <Typography variant="body2">
        Selected: {selected.length ? selected.join(", ") : "None"} | Logic:{" "}
        {filterLogic.criticalAssets}
      </Typography>
    </Box>
  );
};

export default SearchAndOrFilterDemo;
